/**
 * Saga specifications popup — generic anchor-link trigger.
 *
 * This popup section is not wired to any specific button anywhere in the
 * theme. Any <a href="#some-id"> whose target element carries the
 * data-saga-popup attribute (which sections/saga-specs-modal.liquid renders
 * on its own root) opens that popup — a merchant sets the link themselves,
 * with no code coupling between the trigger and the popup it opens. The
 * click listener below is the only thing that makes that link do anything;
 * it's registered once regardless of how many popup sections exist on the
 * page.
 *
 * Focus trap and scroll lock are the theme's own
 * Alpine.store('xModal'/'xFocusElement'/'xPopup') from assets/theme.js — the
 * same ones sections/cart-drawer.liquid and sections/quick-view.liquid use.
 * This file only adds what those stores don't cover: which popup (if any) is
 * open, which group-page is active (real tab switching — one group visible
 * at a time, not a scroll-and-highlight list), and add-to-cart delegation.
 */
document.addEventListener('alpine:init', () => {
  if (!Alpine.store('xPopups')) {
    Alpine.store('xPopups', {
      openId: null,
      _lastTrigger: null,

      open(id, trigger) {
        this.openId = id;
        this._lastTrigger = trigger || null;
        Alpine.store('xPopup').open = true;
      },

      close() {
        this.openId = null;
        Alpine.store('xFocusElement').removeTrapFocus();
        Alpine.store('xPopup').close();
        const trigger = this._lastTrigger;
        this._lastTrigger = null;
        if (trigger) trigger.focus();
      },
    });
  }

  if (!window.__sagaPopupLinksBound) {
    window.__sagaPopupLinksBound = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !target.hasAttribute('data-saga-popup')) return;
      event.preventDefault();
      Alpine.store('xPopups').open(id, link);
    });
  }

  Alpine.data('xSpecsPanel', (firstGroup) => ({
    activeGroup: firstGroup || '',

    showGroup(groupId) {
      this.activeGroup = groupId;
    },

    addToCart() {
      document.querySelector('form[data-type="add-to-cart-form"] [name="add"]')?.click();
      Alpine.store('xPopups').close();
    },

    close() {
      Alpine.store('xPopups').close();
    },
  }));
});
